export default __webpack_public_path__ + "static/media/pokemon_fairy.11167f82.png";